
<div id="resultsContainerWrapper" class="resultsContainer" *ngIf="resultObject.hasResults">
  <p-table #dt [columns]="resultObject.displayColumns" [value]="resultObject.rows" 
    [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]" [rows]="tableRows" pageLinks="10">
    <ng-template pTemplate="caption"><span *ngIf="!dt.filteredValue">{{resultObject.resultMessage}}</span>
    <span *ngIf="dt.filteredValue && dt.filteredValue.length > 0">Search Results: {{dt.totalRecords}} accounts</span>
      <div style="float: right; font-size: 14px;">
        <button type="button" pButton icon="fa fa-file-zip-o" [disabled]="exportDisabled" iconPos="left"
          label="Export this data sub-set as CSV" (click)="makeCSV(dt)" style="font-size: 14px;">
        </button>
      </div>      
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of resultObject.displayColumns" [pSortableColumn]="col.sortName" [ngStyle]="{width:col.width}">{{col.label}}
          <p-sortIcon [field]="col.sortName"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of resultObject.displayColumns">
          <input type="text" (input)="dt.filter($event.target.value, col.sortName, 'contains')">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.format">
          <div *ngSwitchCase="'currency'" class="pull-right">{{row[col.sortName]||0 | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
          <div *ngSwitchCase="'number'" class="pull-right">{{row[col.sortName]||0 | number}}</div>
          <div *ngSwitchCase="'date'" class="pull-right">{{row[col.sortName] | date:'MM-dd-yyy'}}</div>
          <div *ngSwitchCase="'year'" class="pull-right">{{row[col.sortName]}}</div>
          <div *ngSwitchCase="'percent'" class="pull-right">{{row[col.sortName] | percent}}</div>
          <div *ngSwitchCase="'zipcode'" class="pull-right">{{row[col.sortName] | slice:0:5}}</div>
          <div *ngSwitchCase="'accountLink'"><a class="accountLink" target="blank" href="{{environment.detailUrl  + maxYear + '/'}}{{row[col.sortName]}}">{{row[col.sortName]}}</a></div>
          <div *ngSwitchDefault>{{row[col.sortName]}}</div>
        </td>
      </tr>
    </ng-template>
    <!-- <ng-template pTemplate="summary">
      <div class="ui-helper-clearfix">
        <div class="pull-right">Rows to display:
          <p-dropdown
            [options]="[{label:10, value:10},{label:25, value:25},{label:50, value:50},{label:100, value:100}]" [(ngModel)]="tableRows"></p-dropdown>
        </div>
      </div>
    </ng-template> -->
  </p-table>
</div>
